import React, { FC, ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import AccountsTab from "../../../containers/accounts-tab";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Category } from "../../../models/Category";
import { getMobileAccounts } from "../../../services/mobileAccountService";
import { showError } from "../../../services/utilities/ServiceError";
import EmailAccountsTab from "../../../containers/email-accounts-tab";
import { getAllEmailAccounts } from "../../../services/emailAccountService";

const MobileAccounts: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            const accounts = await getMobileAccounts();
            const emailAccounts = await getAllEmailAccounts(translate)
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.accounts),
                    heading: translate.byKey(TranslationKeys.accounts),
                    value: "",
                    id: 0,
                    count: accounts.pagination.totalCount,
                },
                {
                    displayName: translate.byKey(TranslationKeys.emailAccounts),
                    heading: translate.byKey(TranslationKeys.emailAccounts),
                    value: "",
                    id: 1,
                    count: emailAccounts.pagination.totalCount,
                },
            ]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }

    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <AccountsTab></AccountsTab>, 
                <EmailAccountsTab setBusy={setBusy} categories={categories} setCategories={setCategories}></EmailAccountsTab>
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden"
            >
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/configuration",
                                displayName: translate.byKey(TranslationKeys.configuration),
                                disableClick: true
                            },
                            {
                                value: "/access-control/configuration/accounts",
                                displayName: translate.byKey(TranslationKeys.accounts),
                            },
                        ]}
                        onClick={(item) => history.push(item.value)}
                    ></Breadcrumb>
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default MobileAccounts;
